var map = {
	"./CartPageExtensions": 92418,
	"./CartPageExtensions.ts": 92418,
	"./CompactHeaderExtensions": 14243,
	"./CompactHeaderExtensions.ts": 14243,
	"./FooterExtensions": 60908,
	"./FooterExtensions.ts": 60908,
	"./HeaderExtensions": 54498,
	"./HeaderExtensions.ts": 54498,
	"./HomePageExtensions": 84607,
	"./HomePageExtensions.ts": 84607,
	"./ProductDetailsPageExtensions": 66703,
	"./ProductDetailsPageExtensions.ts": 66703,
	"./UserSetupPageExtensions": 41592,
	"./UserSetupPageExtensions.ts": 41592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34212;